import { postRequest, createDateObject } from '@/core';
import { deviations } from '@/requests';

export default async function newDeviationRequest(deviation) {
	let url = deviations.getPath();
	deviation.registeredDate = createDateObject();
	return postRequest(url, {},  deviation);
}
